<template>
  <div class="overview-header">
    <CalendarNavigation :momentLastConnected="momentLastConnected"
      :isNetworkAvailable="isNetworkAvailable"
      :location="location"
      :calendarDate="calendarDate"
      :darkMode="darkMode"
      @setCalendarDate="setCalendarDate"
      @now="$emit('now')" />
    <div class="overviewactions"
      v-if="isNetworkAvailable">
      <UIButton
      :class="darkMode ? 'darkHeader' : ''"
      ghost
        @click="toggleDarkMode">
        <div>{{ darkMode ? $t('Light Mode') : $t('Dark Mode') }}</div>
      </UIButton>
        <UIButton :to="{ name: 'remote-launch', query: {darkMode: darkMode} }" :class="darkMode ? 'darkHeader' : ''"
          ghost>{{ $t("Remote Launch") }}</UIButton>
        <UIButton @click="goToNewBooking">{{ $t("Reservation") }}</UIButton>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import CalendarNavigation from './calendar/CalendarNavigation';
import UIButton from '@/core/shared/components/ui/UIButton';
import UISwitch from '@/core/shared/components/ui/UISwitch';
import UIIcon from '@/core/shared/components/ui/UIIcon';

@Component({
  components: {
    CalendarNavigation,
    UIButton,
    UIIcon,
    UISwitch,
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
    calendarDate: {
      type: String,
      required: true,
    },
    isNetworkAvailable: {
      type: Boolean,
      required: true,
    },
    momentLastConnected: {
      type: [String, null],
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
})
export default class OverviewHeader extends Vue {
  setCalendarDate (time) {
    this.$emit('setCalendarDate', time);
  }

  goToNewBooking () {
    this.$emit('setOverviewScrollPosition');
    this.$router.push({
      name: 'booking',
      params: {
        bookingId: 'new',
        darkMode: this.darkMode,
      },
    });
  }

  toggleDarkMode () {
    this.$emit('toggleDarkMode');
  }
}
</script>
<style scoped lang="postcss">
@import "core/shared/styles";

.overview-header {
  padding: var(--spacingSm);
  display: grid;
  grid-gap: var(--spacingSm);

  & .overviewactions {
    display: flex;

    &>* {
      display: flex;
      gap: 5px;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-right: var(--spacingSm);

      &:last-child {
        margin-right: 0;
      }
    }
  }

  @media (--tablet) {
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: column;

    & .calendar-navigation {
      justify-self: start;
    }

    & .overviewactions {
      grid-template-columns: 1fr 1fr;
      justify-self: end;
      justify-items: end;

      &>* {
        width: auto;
      }
    }
  }
}

.overview-header.dark-mode {
  background-color: black;
  color: white;
  padding: var(--spacingSm);
  display: grid;
  grid-gap: var(--spacingSm);

  & .overviewactions {
    display: flex;

    &>* {
      display: flex;
      gap: 5px;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding-right: var(--spacingSm);

      &:last-child {
        padding-right: 0;
      }
    }
  }

  @media (--tablet) {
    grid-template-columns: 1fr 1fr;
    grid-auto-flow: column;

    & .calendar-navigation {
      justify-self: start;
    }

    & .overviewactions {
      grid-template-columns: 1fr 1fr;
      justify-self: end;
      justify-items: end;

      &>* {
        width: auto;
      }
    }
  }
}

.darkHeader {
  background-color: var(--darkModeColorDarkBackground) !important;
  color: var(--darkModeColorText) !important;
}
.darkRemoteLaunch {
  background-color: var(--darkModeColorDarkBackground) !important;
  color: var(--darkModeColorText) !important;
}
.darkRemoteLaunch .content- {
  background-color: var(--darkModeColorDarkBackground) !important;
  color: var(--darkModeColorText) !important;
}
</style>
